/**
 * Composant racine de l'application avec le système de routage.
 */

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { TeamViewProvider } from "./contexts/TeamViewContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import ContactListPage from "./pages/ContactListPage";
import ContactFormPage from "./pages/ContactFormPage";
import ContactDetailPage from "./pages/ContactDetailPage";
import ContactTimelinePage from "./pages/ContactTimelinePage";
import ContactTodosPage from "./pages/ContactTodosPage";
import ContactActionsPage from "./pages/ContactActionsPage";
import TodoListPage from "./pages/TodoListPage";
import TodoFormPage from "./pages/TodoFormPage";
import SpontaneousActionListPage from "./pages/SpontaneousActionListPage";
import SpontaneousActionFormPage from "./pages/SpontaneousActionFormPage";
import AdminUserListPage from "./pages/AdminUserListPage";
import AdminUserFormPage from "./pages/AdminUserFormPage";
import AdminSquadListPage from "./pages/AdminSquadListPage";
import AdminPracticeListPage from "./pages/AdminPracticeListPage";
// Charge en dernier : neutralise les etats de survol sur les appareils tactiles
import "./touch.css";

export default function App() {
  return (
    <AuthProvider>
      <TeamViewProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* Routes protégées (utilisateur connecté) */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              {/* Contacts */}
              <Route path="/contacts" element={<ContactListPage />} />
              <Route path="/contacts/new" element={<ContactFormPage />} />
              <Route path="/contacts/:id" element={<ContactDetailPage />} />
              <Route path="/contacts/:id/edit" element={<ContactFormPage />} />
              <Route path="/contacts/:id/timeline" element={<ContactTimelinePage />} />
              <Route path="/contacts/:id/todos" element={<ContactTodosPage />} />
              <Route path="/contacts/:id/actions" element={<ContactActionsPage />} />

              {/* To Dos */}
              <Route path="/todos" element={<TodoListPage />} />
              <Route path="/todos/new" element={<TodoFormPage />} />
              <Route path="/todos/:id/edit" element={<TodoFormPage />} />

              {/* Actions Spontanées */}
              <Route path="/actions" element={<SpontaneousActionListPage />} />
              <Route path="/actions/new" element={<SpontaneousActionFormPage />} />
              <Route path="/actions/:id/edit" element={<SpontaneousActionFormPage />} />

              {/* Administration (admin uniquement) */}
              <Route element={<AdminRoute />}>
                <Route path="/admin/users" element={<AdminUserListPage />} />
                <Route path="/admin/users/new" element={<AdminUserFormPage />} />
                <Route path="/admin/squads" element={<AdminSquadListPage />} />
                <Route path="/admin/practices" element={<AdminPracticeListPage />} />
              </Route>
            </Route>
          </Route>

          {/* Redirection par défaut */}
          <Route path="*" element={<Navigate to="/contacts" replace />} />
        </Routes>
      </BrowserRouter>
      </TeamViewProvider>
    </AuthProvider>
  );
}
